export const DYNAMIC_INSIGHT_PREPEND_INDICATOR = 'dynamic-insight_'; // used for prepending attributes to indicate that it's a dynamic insight
